import { render, staticRenderFns } from "./create.vue?vue&type=template&id=70761f94&scoped=true"
import script from "./create.vue?vue&type=script&lang=js"
export * from "./create.vue?vue&type=script&lang=js"
import style0 from "./create.vue?vue&type=style&index=0&id=70761f94&prod&lang=scss"
import style1 from "./create.vue?vue&type=style&index=1&id=70761f94&prod&scoped=true&lang=css"
import style2 from "./create.vue?vue&type=style&index=2&id=70761f94&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70761f94",
  null
  
)

export default component.exports